import React, { ReactElement } from "react";

import Link from "next/link";
import { PopoverClose } from "@radix-ui/react-popover";

export default function HeaderNavigationMenuItem({
  onClick,
  href,
  icon,
  children,
  linkAriaLabel,
  target,
}: {
  onClick: () => void;
  href?: string;
  icon: ReactElement;
  children: React.ReactNode;
  linkAriaLabel: string;
  target?: React.HTMLAttributeAnchorTarget;
}) {
  return (
    <li>
      <PopoverClose asChild>
        <Link
          aria-label={linkAriaLabel}
          href={href || "#"}
          className="flex items-center justify-start w-full px-4 py-2 text-gray-800 transition-colors duration-150 ease-in-out gap-x-2 hover:bg-gray-50"
          onClick={onClick}
          target={target}
        >
          <div className="flex items-center justify-center">{icon}</div>
          {children}
        </Link>
      </PopoverClose>
    </li>
  );
}
